module.exports = "../../app/cells/pages/question/related_exams_cell.rb";